// extracted by mini-css-extract-plugin
export default {"articleFooter":"articleFooter--xmXbt","separator":"separator--qlesJ"};